interface InventoryRecord {
    drugId: string;
    remainingQuantityAccordingToUser: number;
    description?: string | null;
}

interface InventoryItem {
    drugName: string;
    antal: number;
    mismatch: boolean;
}

interface InventoryRecordsSlice {
    inventoryRecords: InventoryRecord[];
    setInventoryRecords: (records: InventoryRecord[]) => void;
    resetInventoryRecords: () => void;

    inventoryList: InventoryItem[];
    setInventoryList: (list: InventoryItem[]) => void;
    resetInventoryList: () => void;
}

const createInventoryRecordsSlice = (set): InventoryRecordsSlice => ({
    inventoryRecords: [],
    setInventoryRecords: (records) => {
        set({ inventoryRecords: records });
        set({ showSigningInInventory: records.length > 0 });
    },
    resetInventoryRecords: () => {
        set({ inventoryRecords: [] });
        set({ showSigningInInventory: false });
    },

    inventoryList: [],
    setInventoryList: (list) => set({ inventoryList: list }),
    resetInventoryList: () => set({ inventoryList: [] }),
});

export { createInventoryRecordsSlice };
export type { InventoryRecordsSlice, InventoryRecord, InventoryItem };
